import range from 'lodash-es/range';
import zip from 'lodash-es/zip';
import React from 'react';
import {
  GraphExportType,
} from '../../Utils';
import {
  IRibbon,
} from '../../workerStore/stack/Utils';

interface IProps {
  ribbons: IRibbon[];
  exportType: GraphExportType;
}

export default class extends React.PureComponent<IProps> {
  render() {
    const {ribbons, exportType} = this.props;

    const ribbonLabels = ribbons.map(({textInRibbon, id}) => {
      if (textInRibbon.showText === true) {
        const {centerX, centerY, height, angle, textSplitIntoLines, fontSize} = textInRibbon;
        const numOfLines =  textSplitIntoLines.length;

        // Height of single line of text:
        const lineHeight = height / numOfLines;

        // This is the top of the rectangle:
        const yCoordinateOfRectTop = centerY - height / 2;

        let baselineOfFirstLineOfText: number, alignmentBaseline: 'middle' | 'auto';
        if (exportType === GraphExportType.SVG) {
          // Align text's middle baseline with line's middle because SVG
          // supports `alignment-baseline=middle` (whereas the PNG/PDF converter
          // doesn't):
          baselineOfFirstLineOfText = yCoordinateOfRectTop + lineHeight * 0.5;
          alignmentBaseline = 'middle';
        } else {
          // Multiply `lineHeight` by 0.75 because we assume that the actual
          // height of the characters is only about half the height of a line.
          // This implies that the baseline of a line of text is 3/4 from the
          // top of that line:
          baselineOfFirstLineOfText = yCoordinateOfRectTop + lineHeight * 0.75;
          alignmentBaseline = 'auto';
        }

        const textBaselines = range(0, numOfLines).map(index => baselineOfFirstLineOfText + index * lineHeight);

        const zipped = zip(textSplitIntoLines, textBaselines as any) as Array<[string, number]>;

        const lines = zipped.map(([text, baseline], index) => (
          <tspan x={centerX} y={baseline} textAnchor='middle'
            alignmentBaseline={alignmentBaseline} key={index} fontSize={fontSize}>
            {text}
          </tspan>
        ));

        const transform = `rotate(${-angle} ${centerX}, ${centerY})`;
        return (
          <text transform={transform} textAnchor='middle' key={id} fill='white'>
            {lines}
          </text>
        );
      } else {
        return null;
      }
    });

    return (
      <g>{ribbonLabels}</g>
    );

  }
}
